
import { CSSProperties } from "@mui/material/styles/createTypography"
import { IdentityClient } from "api-clients/IdentityClient"
import { PlansClient } from "api-clients/PlansClient"
import { ProductInfoService } from "services/ProductInfoService"
import Container from "components/layout/Container"
import Grid from 'components/layout/grid/Grid'
import Item from 'components/layout/grid/Item'
// import './home.scss';
import Title from "components/labels/Title"
import Subtitle from "components/labels/SubHeading"
import Page from "components/layout/Page"
import Section from "components/layout/Section"
import Button from "components/buttons/Button"
import Box from "components/layout/box/Box"
import Heading from "components/labels/Heading"
import Text from 'components/labels/Text';

import CardFeature from 'views/home/CardFeature'
import { ColorsUtil, MyTheme } from "MyTheme"
import { Avatar, Backdrop, Card, CardActions, CardContent, CardHeader, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack, Step, StepButton, StepLabel, Stepper, ThemeProvider, Toolbar, useMediaQuery, Zoom } from "@mui/material"
import React, { useEffect, useRef, useState, VideoHTMLAttributes } from "react"
import useVisibility from "hooks/UseVisibility"
import Animation from "components/animations/Animation"
import SubHeading from "components/labels/SubHeading"
import TitleBlock from "components/layout/TitleBlock"
import Icon from "components/icons/Icon"
import { VideoMarker, VideoMarkersController } from "utils/VideoUtil"
import Modal from "components/modals/Dialog"
import Dialog from "components/modals/Dialog"
import { Plan } from "models/Plan"
import { Price } from "models/Price"
import FieldCollection from "components/fields/fieldCollection/FieldCollection"
import TextField from "components/fields/textField/TextField"
import { Link as NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { UserService } from "services/UserService"
import Form from "components/forms/Form"
import TabControl, { TabPanel } from "components/tabs/TabControl"
import Tab from "components/tabs/Tab"
import Tabs from "components/tabs/Tabs"
import { PermissionTicket } from "models/PermissionTicket"
import { PermissionRequest } from "models/PermissionRequest"
import { ResourceType } from "models/ResourceType"
import { AppScopes, ScopeUtils } from "models/PermissionScopes"
import { Bootstrapper } from "Bootstrapper"
import { Context } from "./Context"
import CircularProgress from "components/progress/CircularProgress"
import Link from "components/buttons/Link"
import Alert from "components/alerts/Alert"
import Dashboard from "components/dashboard/Dashboard"
import { NavItem } from "components/dashboard/Navbar"

const Admin = (props: any) => {
    const navigate = useNavigate();
    const context = Bootstrapper.getInstance<Context>(Context);
    const userService = new UserService();
    const theme = MyTheme();
    const bg1 = theme.palette.grey[200];
    const bg2 = theme.palette.grey['100'];
    const userId = userService.getActiveUserId();

    const [hasLoaded, setHasLoaded] = useState<boolean>(false);
    const [isBusy, setIsBusy] = useState<boolean>(false);
    const [isAnimationChaining, setIsAnimationChaining] = useState<boolean | null>(null);
    const location = useLocation();

    const handleAnimationChain = () => {
        setIsAnimationChaining(true);
    }




    useEffect(() => {
        context.isBusyEmitter.subscribe(val => {
            setIsBusy(val);
        })
        setHasLoaded(true);
    }, []);


    const getNavItems = () => {
        const items: NavItem[] = [
            new NavItem('Dashboard', '/admin'),
            new NavItem('Users', '/admin/users'),
            new NavItem('Invites', '/admin/invites'),
            new NavItem('Organizations', '/admin/organizations'),
        ];
        return items;
        
    }


    return(
        <Dashboard
            titleBar="Admin"
            navItems={getNavItems()}
            // alerts={!isEmailConfirmed && <Alert flat severity="warning">Please confirm your email <Link underline="always" color="inherit" component={NavLink} to={'/home'}>here</Link></Alert>}
            isBusy={isBusy}
        >
            {hasLoaded && <Outlet />}
        </Dashboard>
    )
}


export default Admin